import ptLocale from "element-ui/lib/locale/lang/pt";
const pt = {
  message: {
    lan: "Pt",
    errorMessage: {
      ServerException: "Erro do servidor",
      ClientException: "Erro do utilizador",
      NetworkException: "Erro desconhecido na rede",
      CheckNetwork: "Verifique a sua ligação à rede",
      UnknownError: "Erro desconhecido",
      captchaError: "Código de verificação inválido! Tente outra vez."
    },
    index: "Início",
    course_learning: "Progresso e aprendizagem do curso",
    course_learn: "Aprendizagem do curso",
    viewed_times: "Número de acessos",
    course_catalog: "Índice",
    learning_progress: "Progressão da aprendizagem",
    view_exam_record: "Consultar os resultados do teste simulado",
    learn_review: "Historial da aprendizagem",
    continue_learning: "Continuar a aprendizagem",
    to_learn: "Iniciar",
    take_the_mock_test: "Fazer teste simulado",
    replay: "Voltar a ouvir/ver",
    play: "Ouvir/Ver",
    pause: "Pausa",
    muteMe: "Silenciar",
    sound: "Ajustar o som",
    search_chapter_placeholder: "Coloque o número do capítulo",
    practice_test: "Teste simulado",
    exam_record: "Historial dos Resultados dos Testes Simulados Realizados",
    course_name: "Nome do curso",
    exam_score: "Resultado do teste",
    operation_time: "Duração da consulta",
    view: "Consultar",
    title_TRUE_OR_FALSE: "Perguntas de Verdadeiro ou Falso",
    title_SINGLE_CHOICE: "Perguntas de Escolha Múltipla (resposta única)",
    title_SHORT_ANSWER: "Perguntas de Resposta Curta",
    title_MULTIPLE_CHOICE: "Perguntas de Escolha Múltipla (várias respostas)",
    correct: "Correcto",
    wrong: "Incorrecto",
    correct_answer: "A sua resposta está Correcta",
    wrong_answer: "A sua resposta está Incorrecta",
    right_key: "Resposta Correcta",
    submit_test: "Entregar o teste",
    next_question: "Pergunta seguinte",
    back: "Voltar atrás",
    exam_result: "Resultado do teste",
    answers_situation: "Pontuação no Teste Simulado",
    return_exam_record: "Voltar aos resultados do teste simulado",
    reTest: "Voltar a fazer o teste",
    back_to_home: "Voltar à página inicial",
    all: "Todos",
    learning: "Em progressão",
    finished_learning: "Curso concluído",
    submit: "Entregar",
    logout: "Sair",
    course_list: "Lista de Cursos",
    prev_section: "Secção Anterior",
    next_section: "Secção Seguinte",
    start_chapter_learn: "Iniciar este capítulo",
    return_prev_chapter: "Voltar para o capítulo anterior",
    return_this_chapter: "Voltar a este capítulo ",
    start_next_chapter: "Ir para o capítulo seguinte",
    to_test: "Ir para o teste de treino",
    chapter_start: "Início do capítulo",
    chapter_end: "Fim do capítulo",
    copyright: "Governo da Região Administrativa Especial de Macau - Direcção dos Serviços para os Assuntos Laborais",
    course_entry: "Iniciar o Curso",
    start_test: "Iniciar o teste",
    test_tips: "O progresso do curso é inferior a 80%. Por favor estude pacientemente antes de fazer o teste.",
    question_tips: "O progresso do curso é inferior a 80%. Por favor estude pacientemente antes de fazer o inquérito avaliativo.",

    tips: "Sugestões",
    confirm: "Confirmar",
    question_already: "O inquérito avaliativo só pode ser preenchido uma vez.",

    exam_excellent: "Parabéns! O seu resultado é Excelente!",
    exam_pass: "Muito bem! Passou no teste simulado.",
    exam_fail: "Mais um esforço! O resultado não é o ideal.",

    submit_success: "Entrega finalizada",
    submit_error: "Entrega não finalizada",

    learning_content: "Conteúdos de aprendizagem",

    priority_tips: "Recomenda-se que estude seguindo esta sequência ",
    goto_course: "Voltar ao curso",
    current: "(Curso actual)",
    no_question: "Pergunta não encontrada",
    public_questionnaires_Invalid: "O inquérito avaliativo do curso expirou ou não foi activado!",

    web_title: "Aprendizagem Virtual da Direcção dos Serviços para os Assuntos Laborais",
    question_public_title: "Direcção dos Serviços para os Assuntos Laborais",
    online_services: "Inscrição Electrónica",
    write_tips: "Por favor complete o inquérito avaliativo para que a Direcção dos Serviços para os Assuntos Laborais possa melhorar este curso virtual. Obrigado! ",
    chapter: "Capítulo {0}",
    section: "Secção {0}",
    question_must_be_completed: "Complete o inquérito avaliativo antes de entregar",
    captcha_plh: "Insira o código de verificação",
    noData: "Dados inexistentes",
    question: "Inquérito avaliativo do curso",
    noVoice: "Áudio em português não está disponível.",
    numberToCN: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59"
    ],
    question_tips_content: "A fim de melhorar o sistema de eLearning do [<b>{0}</b>], gostaríamos de o/a convidar a preencher um questionário online para nos ajudar a melhorar o nosso serviço. Muito obrigado!",
    question_tips_btn1: "Clique aqui para preencher o questionário",
    question_tips_btn2: "Ainda não completou o respectivo curso, por favor preencha o questionário depois de o concluir.",
  },
  ...ptLocale
};
export default pt;